import api from '@/api/api'
import { childApps } from '../config'
import router, { routes } from '@/router'
import Store from '@/store'

const env = require('../../env')

// 跳转飞书登录
export const feishuLogin = () => {
  let appId = 'cli_a1ed66b33778d00c' // local/dev/uat 环境
  let { origin } = location
  if (process.env.NODE_ENV === 'development') origin = 'http://operation-local.aupup.com:9000'
  if ((process.env.VUE_APP_CUR_ENV) === 'prod') appId = 'cli_a1e4335990f9d013' // prod环境appId
  /*
    redirect_uri：后端生成登录态
    state：登录后跳转的url
  */
  location.href = `https://open.feishu.cn/open-apis/authen/v1/index?app_id=${ appId }&redirect_uri=${ origin }/v1/api/identity-admin/feishu/login&state=${ origin }`
}

// 跳转企业微信登录
export const wxcpLogin = () => {
  let appId = 'ww8ca9621c5334ea46'
  let profile = process.env.VUE_APP_CUR_ENV
  let agentId = env[profile].AGENT_ID
  let serverUri = env[profile].BACKEND_URL
  let localHref = location.href
  let redirectUri = serverUri
  if (localHref.indexOf('returnUrl=') !== -1) {
    let sub1 = localHref.split('returnUrl=')[1]
    if (sub1.indexOf('&') !== -1) {
      // eslint-disable-next-line prefer-destructuring
      redirectUri = sub1.split('&')[0]
    } else {
      redirectUri = sub1
    }
  }
  location.href = `https://login.work.weixin.qq.com/wwlogin/sso/login?login_type=CorpApp&appid=${ appId }&agentid=${ agentId }&redirect_uri=${ serverUri }v1/api/identity-admin/wxcp/qrAuthorize&state=${ redirectUri }`
}

// 1. 获取权限
export function getAppsPermission() {
  return new Promise((resolve, reject) => {
    api.getRolePermissionTrees()
      .then(({ data }) => {
        if (!data || !data.length) {
          // location.href = '/error?msg=该账户未配置权限, 请联系管理人员'
          return resolve([])
        }
        Store.commit('setUserApps', data)
        // 向有权限的子应用注册权限树
        let registerApps = []
        data.forEach((workbench) => {
          const { console: consoleConf, roleTree } = workbench
          let temp = childApps.find((app) => app.name === consoleConf.consoleId)
          if (!temp) return
          temp.props.permissionTree = roleTree || [] // 子应用权限树注入
          temp.label = consoleConf?.desc || '未命名工作台' // 子应用名称
          registerApps.push(temp)
        })
        // =====
        // 子应用需要的一些信息
        let childFields = registerApps.map((app) => {
          const {
            label, name, entry, container, activeRule, showTopBar
          } = app
          return {
            label, name, entry, container, activeRule, showTopBar
          }
        })
        registerApps.forEach((app) => {
          app.props.registerApps = childFields
        })
        // =====

        Store.commit('setRegisterApps', registerApps)
        resolve(registerApps)
      })
      .catch((err) => {
        reject(err)
        // feishuLogin()
        location.href = `/login?returnUrl=${ location.href }`
      })
  })
}

// 2. 路由拦截
export function routerPermission(registerApps) {
  // 过滤主应用通配路由* path
  const mainAppRoutes = routes.filter((item) => item.path.includes('/'))
  // 可访问路由：主应用路由 + 子应用路由前缀
  // 否则路由打向404
  const whiteList = [...registerApps.map(({ activeRule }) => activeRule), ...mainAppRoutes.map(({ path }) => path)]
  router.beforeEach((to, from, next) => {
    if (!whiteList.some((item) => to.path?.includes(item))) return next('/404')
    next()
  })
}

export function isPhoneValid(val) {
  const reg = /^[1][0-9]{10}$/
  return reg.test(val)
}

export function isCodeValid(val) {
  const reg = /[0-9]{4}$/
  return reg.test(val)
}
